import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NotificationService } from '../../../services/notification/notification.service';
import { NotificacaoView } from '../../../models/NotificacaoView';

@Component({
  selector: 'app-notificacoes-detalhes',
  imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule],
  templateUrl: './notificacoes-detalhes.html',
  styleUrl: './notificacoes-detalhes.scss',
})
export class NotificacoesDetalhes implements OnInit {
  todasNotificacoes: NotificacaoView[] = [];
  clickedNotificacao!: NotificacaoView;
  total = 0;
  currentIndex = 0;
  public isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NotificacoesDetalhes>,
    private notificacaoService: NotificationService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.clickedNotificacao = this.data.notificacaoClicada;
    this.carregarNotificacoes();
  }

  next(): void {
    if (this.currentIndex < this.total - 1) {
      this.currentIndex++;
      this.atualizarNotificacaoAtual();
    }
  }

  previous(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.atualizarNotificacaoAtual();
    }
  }

  private atualizarNotificacaoAtual(): void {
    this.clickedNotificacao = this.todasNotificacoes[this.currentIndex];
    const jaEstavaVisualizado =
      this.clickedNotificacao.status?.toLowerCase() === 'visualizado';

    if (!jaEstavaVisualizado) {
      this.notificacaoService
        .visualizarNotificacao(this.clickedNotificacao.id)
        .subscribe({
          next: () => {
            this.clickedNotificacao.status = 'visualizado';
            this.notificacaoService.handleNotificacaoVisualized();
          },
          error: (err) => {
            console.error('Erro ao marcar notificação como visualizada', err);
          },
        });
    }
  }

  private encontrarIndiceNotificacao(): void {
    if (this.clickedNotificacao && this.todasNotificacoes.length > 0) {
      const foundIndex = this.todasNotificacoes.findIndex(
        (notificacao) => notificacao.id === this.clickedNotificacao.id
      );

      if (foundIndex !== -1) {
        this.currentIndex = foundIndex;
        this.clickedNotificacao = this.todasNotificacoes[foundIndex];
      } else {
        this.currentIndex = 0;
        this.clickedNotificacao = this.todasNotificacoes[0];
      }
    }
  }

  async carregarNotificacoes() {
    try {
      this.todasNotificacoes = this.data.notificacoes.map(
        (notificacao: any) => {
          return {
            ...notificacao,
          };
        }
      );

      this.total = this.todasNotificacoes.length;
      this.encontrarIndiceNotificacao();

      if (this.currentIndex === -1 || !this.clickedNotificacao) {
        this.currentIndex = 0;
        this.clickedNotificacao = this.todasNotificacoes[0];
      }

      this.isLoading = false;
    } catch (err) {
      console.error('Falha ao carregar as notificações:', err);
      this.isLoading = false;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
